import { connect } from 'react-redux';
import CardsTable from './index';
import { mapStateToProps, mapDispatchToProps } from './index.props';

export default connect(mapStateToProps, mapDispatchToProps)(CardsTable);
